import {
  Http
} from '@/model/Http.js'

export default class sort extends Http {
  // 订单排名
  getOrderList(data){
    const url = 'api/open/user/search-rank'
    return this.postAjaxByKfc(url, {
      ...data
    })
  }
}



// WEBPACK FOOTER //
// ./src/javaApi/kfc/sort.js